// extracted by css-extract-rspack-plugin
export default {"restrictionBanner":"header-fragment__Header_restrictionBanner__guxsC"};